import { Button, styled } from '@mui/material';

const StyledProfileChangePasswordButton = styled(Button)(() => ({
	borderRadius: '8px',
	padding: '8px 16px',
	height: '48px',
	boxShadow: '0px 0px 30px 0px #827D8326',
	width: '100%',
}));

export default StyledProfileChangePasswordButton;
